import { useTranslation } from 'react-i18next'

import { FooterItem } from '../../../footer.interface'

export function LinksConfig() {
  const { t } = useTranslation('footer')

  const firstColumnItems: FooterItem[] = [
    {
      label: 'Morar',
      path: 'https://housi.com/',
      isExternal: true,
    },
    {
      label: 'Decorar',
      path: 'https://housi.com/decorar',
      isExternal: true,
    },
    {
      label: 'Investir',
      path: 'https://housi.com/investir',
      isExternal: true,
    },
    {
      label: 'Construir',
      path: 'https://housi.com/construir',
      isExternal: true,
    },
    {
      label: 'Conectar',
      path: 'https://housi.com/conectar',
      isExternal: true,
    },
  ]

  const secondColumnItems: FooterItem[] = [
    {
      label: t('footer:links.LINK1'),
      path: 'https://lps.housi.com/quemsomos',
      isExternal: true,
    },
    {
      label: t('footer:links.LINK5'),
      path: 'https://www.inhire.com.br/carreiras-housi',
      isExternal: true,
    },
    {
      label: t('footer:links.LINK6'),
      path: '/blog',
      isExternal: true,
    },
    {
      label: 'Termos e Condições - Moradia',
      path: '/termos-e-condicoes',
      isExternal: false,
    },
  ]

  const thirdColumnItems: FooterItem[] = [
    {
      label: 'Central de ajuda',
      path: 'https://api.whatsapp.com/send?1=pt_BR&phone=5511916678278',
      isExternal: true,
    },
    {
      label: 'Termos de Uso e cancelamento',
      path: 'https://lps.housi.com/faq/',
      isExternal: false,
    },
  ]

  return {
    firstColumnItems,
    secondColumnItems,
    thirdColumnItems,
  }
}
